"use client"

import { motion } from "framer-motion"
import { Variants } from "framer-motion";
import Link from "next/link"
import { Mail, MapPin, Clock, Facebook, Twitter, Instagram, Linkedin, CreditCard } from "lucide-react"
import { FaYoutube } from "react-icons/fa";

export default function Footer() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  }

  const itemVariants: Variants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  }

  return (
    <footer className="bg-[#2a1d10] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12 pb-12 border-b border-gray-700"
        >
          {/* About */}
          <motion.div variants={itemVariants} className="space-y-4">
            <h3 className="text-lg font-bold mb-4">About Us</h3>
            <p className="text-white/80 text-sm leading-relaxed">

            </p>
            <div className="flex gap-4 pt-4">
              <Link href={"https://www.facebook.com/mypreneuredu"}><Facebook className="w-5 h-5 text-white/80 hover:text-primary_hover cursor-pointer transition" /></Link>
              <Link href={"https://www.youtube.com/@sureshradhakrishnan?si=CMeUZLqvXJy5iYTt"}> <FaYoutube className="w-5 h-5 text-white/80 hover:text-primary_hover cursor-pointer transition" /></Link>
              <Link href={"https://www.instagram.com/mypreneuredu/"}><Instagram className="w-5 h-5 text-white/80 hover:text-primary_hover cursor-pointer transition" /></Link>
              <Link href={"https://www.linkedin.com/company/mypreneur/"}> <Linkedin className="w-5 h-5 text-white/80 hover:text-primary_hover cursor-pointer transition" /></Link>
            </div>
          </motion.div>

          {/* Quick Links */}
          <motion.div variants={itemVariants} className="space-y-4">
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {[
  { name: "Home", href: "/" },
  { name: "Equipment", href: "/products" },
  { name: "About Us", href: "/about-us" },
  { name: "Blog", href: "/blog" },
  { name: "Contact US", href: "/contact-us" },
].map((link) => (
  <li key={link.name}>
    <Link
      href={link.href}
      className="text-white/80 hover:text-primary_hover transition text-sm"
    >
      {link.name}
    </Link>
  </li>
))}

            </ul>
          </motion.div>

          {/* Customer Service */}
          <motion.div variants={itemVariants} className="space-y-4">
            <h3 className="text-lg font-bold mb-4">Customer Service</h3>
            <ul className="space-y-2">
              {["FAQs", "Shipping & Installation", "Warranty & Returns", "Support", "Privacy Policy"].map((link) => (
                <li key={link}>
                  <Link href="#" className="text-white/80 hover:text-primary_hover transition text-sm">
                    {link}
                  </Link>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Contact Info */}
          <motion.div variants={itemVariants} className="space-y-4">
            <h3 className="text-lg font-bold mb-4">Contact Info</h3>
            <div className="space-y-3 text-sm text-white/80">
              <div className="flex gap-3 items-start">
                <Mail className="w-5 h-5 flex-shrink-0 mt-1" />
                <span>modernteapreneur@gmail.com</span>
              </div>
              <div className="flex gap-3 items-start">
                <MapPin className="w-5 h-5 flex-shrink-0 mt-1" />
                <span>218, Manapakkam-Mugaliwakkam Main Rd, Ramapuram, Arumugam Nagar, Periya Palayatamman Nagar, Manapakkam, Chennai, Tamil Nadu 600125</span>
              </div>
              {/* <div className="flex gap-3 items-start">
                <Clock className="w-5 h-5 flex-shrink-0 mt-1" />
                <span>Mon – Sat: 9:00 AM – 7:30 PM IST</span>
              </div> */}
            </div>
          </motion.div>
        </motion.div>

        {/* Payment Methods */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          className="pb-8 border-b border-gray-700"
        >
          <p className="text-sm text-white/80 mb-4">We accept the following payment methods:</p>
          <div className="flex flex-wrap gap-4">
            <img src="https://assetsvilva.blr1.cdn.digitaloceanspaces.com/thaithingal/HomepageImages/footer-img.webp" alt="" />
          </div>
        </motion.div>

        {/* Copyright */}
        <div className="pt-8 text-center text-sm text-gray-500">
          <p> © 2025 Mypreneur All rights reserved. Developed & Maintained By <Link href="https://www.vilvabusiness.com/products/ecom-saas" target="_blank" className="hover:text-gray-300"> Vilva Ecom SaaS. </Link>
          </p>
        </div>
      </div>
    </footer>
  )
}
